import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { notifyError, notifySuccess } from "../utils/notificationMsg";
import useLoading from "./LoadingHook";
import { useGlobalData } from "../contexts/GlobalDataContext";

const useConfirmationDialog = () => {
  const [open, setOpen] = useState(false);
  const [currentAction, setCurrentAction] = useState(null);
  const { isLoading, startLoading, stopLoading } = useLoading();
  const { fetchData, checkStripeAccount } = useGlobalData();
  const dispatch = useDispatch();

  const handleOpenDialog = (action) => {
    setCurrentAction(action);
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setCurrentAction(null);
    setOpen(false);
  };

  const handleConfirmAction = async (apiAction, data , getHiredCandidatesReportClient) => {
    if (!currentAction) return;
    startLoading();
    try {
      const { payload } = await dispatch(apiAction(data));
      if (payload.status === 200) {
        notifySuccess(payload.msg);
        fetchData()
        if (getHiredCandidatesReportClient) {
          getHiredCandidatesReportClient();
        }
        if (currentAction === "deleteStripeConnect") {
          checkStripeAccount(payload.data?._id?.$oid);
        }
      } else {
        notifyError(payload.data || payload.msg);
      }
    } catch (error) {
      console.error(error);
      notifyError("An error occurred while processing your request");
    } finally {
      handleCloseDialog();
      stopLoading();
    }
  };

  return {
    open,
    handleOpenDialog,
    handleCloseDialog,
    handleConfirmAction,
    isLoading,
    currentAction,
  };
};

export default useConfirmationDialog;
